
<template>
  <!-- 特殊护理记录列表 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="月份">
          <el-date-picker
            v-model="filteForm.dayStr"
            :clearable="false"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择月份"
          />
        </el-form-item>
        <el-form-item label="老人姓名">
          <el-autocomplete
              v-model.trim="filteForm.oldName"
              auto-complete="off"
              placeholder="请选择老人"
              :fetch-suggestions="queryOlder"
              @select="SelectOlder"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="showAddForm">新增</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="dataList" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="日期" align="center" prop="dayStr" />
          <el-table-column label="老人" align="center" prop="oldName" />
          <el-table-column label="项目" align="center" prop="carePj" />
          <el-table-column label="价格" align="center" prop="carePjPrice" >
            <template slot-scope="scope">
              <p>￥{{scope.row.carePjPrice}}</p>
            </template>
          </el-table-column>
          <el-table-column label="护理员" align="center" prop="nursing" />
          <el-table-column label="时间" align="center" prop="createdTime" />
          <el-table-column
            label="照片"
            align="center">
            <template slot-scope="scope">
              <img :src="scope.row.picture" style="height:40px;width:40px"/>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" prop="remark" />
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="filteForm.pageNum"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          align="center"
          class="fenye"
        >
        </el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog title="新增特殊护理" 
        :visible.sync="dialogFormVisible" 
        :close-on-click-modal="false"
        :close-on-press-escape="false" 
        class="dangerbuttonxz" 
        @close="closeDialog">
        <el-form ref="form" :model="addForm">
          <el-row>
            <el-form-item 
              label="老人姓名" 
              :label-width="formLabelWidth"
              prop="oldName">
              <el-autocomplete
                  v-model.trim="addForm.oldName"
                  auto-complete="off"
                  placeholder="请选择老人"
                  class="commonwidth"
                  :fetch-suggestions="queryOlder"
                  @select="SelectOld"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item 
              label="服务项目" 
              :label-width="formLabelWidth"
              prop="careList">
              <el-select 
              v-model="addForm.carePj"
              class="commonwidth" placeholder="请选择">
                <el-option
                  v-for="item in carePj"
                  :key="item.name"
                  :label="item.name+' ￥'+item.price"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="护理员:"
              :label-width="formLabelWidth"
              prop="userName"
            >
              <el-autocomplete
                v-model.trim="addForm.userName"
                auto-complete="off"
                placeholder="请输入护理员"
                class="commonwidth"
                :fetch-suggestions="querynurse"
                @select="SelectUser"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item label="日期" :label-width="formLabelWidth" prop="dayStr">
              <el-date-picker
                v-model="addForm.dayStr"
                type="date"
                :placeholde="today"
                class="commonwidth"
                readonly
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item label="照片" :label-width="formLabelWidth" prop="picture">
              <el-upload
                class="avatar-uploader"
                action="string"
                accept="image/png, image/jpeg"
                :show-file-list="false"
                :http-request="uploadSectionFile"
                :before-upload="uploadSuccess"
                :on-success="successup"
                ref="imagePic">
                <img v-if="addForm.picture" :src="addForm.picture" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
              <el-input v-model.trim="addForm.remark" class="commonwidth" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submitForm('addForm')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  name: "TableCareProject",
  data() {
    return {
      today:"",
      addForm: {},
      filteForm: {
        dayStr: "",
        oldId:"",
        oldName:"",
        pageNum:1,
        pageSize:10
      },
      carePj:[],
      dataList: [],
      currentPage: 1,
      addLoading:false,
      totalDataNumber: 0,
      pageNum: 1,
      formLabelWidth: '120px',
      loading: false,
      dialogShowVisible: false,
      dialogList:[],
      dialogFormVisible: false
    };
  },
  methods: {
    //点击查询
    onSubmit() {
      this.getTableData();
    },
    
    //上传图片
    uploadSectionFile(param) {
      var fileObj = param.file;
      console.log(param.file);
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.addForm.picture = res.result; //添加图片
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    successup(response, file, fileList) {
      this.$refs["imagePic"].clearValidate();
    },
    uploadSuccess(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PGN 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 3MB!");
      }
      return isJPG && isLt2M;
    },
    showAddForm(){
      this.addForm = {
        oldName:"",
        carePj:"",
        price:0,
        userName:"",
        dayStr:this.today,
        picture:null,
        remark:"",
      };
      this.dialogFormVisible = true;
    },
    /* 
    模糊查询老人
    */
    queryOlder(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        this.oldmanList = res.result.list;
        var list = [];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.oldName = "";
          }, 1000);
        }
      });
    },
    SelectOld(item){
      this.addForm.oldId = item.oldmanId;
      this.addForm.oldName = item.oldName;
    },
    /* 
      根据负责人获取负责人id
    */
    SelectOlder(item) {
      this.filteForm.oldId = item.oldmanId;
      this.filteForm.oldName = item.oldName;
    },
    /* 
    模糊查询负责人
    */
    querynurse(queryString, cb) {
      let param = {
        userName: queryString
      };
      this.$postJson("uac/emp/queryEmpListWithPage", param).then((res) => {
        this.nurseList = res.result.list;
        var list = [];
        if (res.result.list) {
          for (let i of res.result.list) {
            i.value = i.userName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据负责人获取负责人id
    */
    SelectUser(item) {
      this.addForm.nursing = item.userName;
    },
    closeDialog() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    handleDetail(index,row){
      this.dialogShowVisible = true;
      this.dialogList = row.tableCarePjBeanList;
    },
    //删除
    handleDelete(index, row) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        }).then(() => {
          let id = row.id;
          console.log(id);
          this.$postJson("omc/table/deleteCare/" + id).then((res) => {
            if (res.code == 200) {
              console.log(res);
              this.$message({
                type: "success",
                message: res.message,
              });
              this.getTableData();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
    },
    // 新增弹出框点击确定提交信息
    submitForm() {
      this.addLoading = true;
      this.carePj.forEach(item2=>{
        if(item2.name == this.addForm.carePj){
          this.addForm.carePjPrice = item2.price;
        }
      })
      let param = this.addForm;
      this.$postJson(
          "omc/table/saveCarePj",
          param
        ).then(res=>{
          if (res.code != "200") {
            this.addLoading = false;
            this.$message({
              message: res.message,
              type: "error",
            });
          }else{
            this.addLoading = false;
            this.dialogFormVisible = false;
            this.$refs.form.resetFields(); //移除校验结果并重置字段值
            this.getTableData();
          }
        })
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      if(this.filteForm.oldName == null || this.filteForm.oldName == ''){
        this.filteForm.oldId = '';
      }
      let param = {
        dayStr: this.filteForm.dayStr,
        oldId:this.filteForm.oldId,
        pageNum:this.filteForm.pageNum,
        pageSize:this.filteForm.pageSize,
        carePjFlag:1
      };
      if(param.oldId == null || param.oldId == ''){
        delete(param.oldId);
      }
      console.log(param);
      this.loading = true;
      this.$postJson("omc/table/selectCareByYear", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.length != 0) {
              this.dataList = res.result.list;
                this.totalDataNumber = Number(res.result.total);
            setTimeout(() => {
              this.loading = false;
            }, 100);
          } else {
            this.dataList = [];
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    /*
      当前页变化
    */
    handleCurrentChange(val) {
      this.filteForm.pageNum = val;
      this.getTableData(); //刷新套餐列表的数据
    },
    getCarePj(){
      this.$postJson("omc/expenseType/queryAll").then(
        (res) => {
          //判断是否有数据
          let carePj = [];
          res.result.forEach(item=>{
            if(item.code == 5){
              item.expenseItemList.forEach(item2=>{
                carePj.push(
                  {
                    name:item2.itemName,
                    price:item2.chargeStandard,
                    costType:item2.costType
                  }
                )
              })
            }
          })
          this.carePj = carePj;
        }
      );
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      return "background-color: #ffffff";
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 14px;background-color: #d4f5fa;";
      }
    },
  },
  created() {
    this.getCarePj();
    //获取月份
    this.today = util.formatDate.format(new Date())
    // const date = {
    //   year: nowDate.getFullYear(),
    //   month: nowDate.getMonth() + 1,
    // };
    // this.filteForm.dayStr = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month);
  },
  mounted() {
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 108px;
  height: 108px;
  line-height: 108px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 108px;
  height: 108px;
  display: block;
}
::v-deep .el-upload{
  width: 108px;
  height: 108px;
}
.fenye {
  margin: 0;
  padding: 20px 0;
  background: #fff;
}

::v-deep .dangerbuttonxz .el-dialog {
  width: 500px !important;
}
.commonwidth{
  width: 260px;
}

</style>